var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopActivityButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F36E70",
    fillOpacity: 0.28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15C9 12.5406 9 11.3109 9.61036 10.4392C9.83617 10.1167 10.1167 9.83617 10.4392 9.61036C11.3109 9 12.5406 9 15 9C17.4594 9 18.6891 9 19.5608 9.61036C19.8833 9.83617 20.1638 10.1167 20.3896 10.4392C21 11.3109 21 12.5406 21 15C21 17.4594 21 18.6891 20.3896 19.5608C20.1638 19.8833 19.8833 20.1638 19.5608 20.3896C18.6891 21 17.4594 21 15 21C12.5406 21 11.3109 21 10.4392 20.3896C10.1167 20.1638 9.83617 19.8833 9.61036 19.5608C9 18.6891 9 17.4594 9 15Z",
    stroke: "#C60513",
    strokeWidth: 1.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopActivityButton);
export default __webpack_public_path__ + "static/media/stop-activity-button.de4c945bb1939e4221bf4fad7e1fa7a5d450342d8649b599d0829d955f1030fb.svg";
export { ForwardRef as ReactComponent };